import React, { useState, useEffect } from "react";

import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";
import { NavLink } from "react-router-dom";
import MUIDataTable from "mui-datatables";
//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

//Material UI Icons
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
// Material UI Component
import {
  FormGroup,
  FormLabel,
  FormControl,
  FormHelperText,
  NativeSelect,
  // ListItemText,
  TextField,
  // Checkbox,
  // FormControlLabel,
  // Grid,
  // Select,
  Input,
  InputLabel,
  // MenuItem,
  Modal,
  Backdrop,
  //Fade,
  fade,
  Button,
  Grid,
  Breadcrumbs,
  Typography,
  Fade,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone, FaceRounded, Update } from "@material-ui/icons";
import { get_cookies, isLoggedIn } from "../../../components/Cookies/Cookies";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MessageBox from "../../../components/MessageBox/MessageBox";
import UpdateSupplier from "./UpdateSupplier";
import DeleteSupplier from "./DeleteSupplier";
const useStyles = makeStyles((theme) => ({
  // modal: {
  //   display: "flex",
  //   alignItems: "center",
  //   justifyContent: "center",
  // },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",

    margin: "0 auto",
  },
  textField: {
    marginTop: "-15px",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "400px",
    maxHeight: "100%",
    overflow: "auto",
  },
}));

const SupplierInfo = () => {
  const [posts, setPosts] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const [open, setOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: addDays(new Date(), 7),
  });
  const [filterType, setFilterType] = useState("1");
  const [supplierName, setSupplierName] = useState("");
  const [address, setAddress] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [otherInfo, setOtherInfo] = useState("");
  const [idno, setIdno] = useState("");
  const [downloadFlag, setDownloadFlag] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [branchIdData, setBranchIdData] = useState([]);
  const [creditData, setCreditData] = useState([]);
  const [branchidno, setBranchidno] = useState("");
  const [credit, setCredit] = useState("");
  const classes = useStyles();

  const [showModalUpdate, setShowModalUpdate] = useState(false);
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("empty");
  const [btnAddDisabled, setBtnAddDisabled] = useState(false);
  const [msgType, setMsgType] = useState("success");
  const [displayView, setDisplayView] = useState(false);
  const [debouncedName, setDebouncedName] = useState(supplierName);
  //console.log(format(dateRange.endDate, "yyyy/MM/dd/"));

  const showModal = (message, type) => {
    setShowMsgBox(true);
    setMsgType(type); //success or warning
    setMsg(message);
    setTimeout(() => {
      setShowMsgBox(false);
      getList();
    }, 2000);
  };
  const selectBranchIdProps = {
    options: branchIdData,
    getOptionLabel: (option) => option.idno,
  };
  const selectCreditProps = {
    options: creditData,
    getOptionLabel: (option) => option.description,
  };

  const getCreditData = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "get_credit", {})
      .then(function (res) {
        setCreditData(res.data.data);
      })
      .catch(function (error) {
        // console.log(error);
      });
  };

  const x = 0;
  useEffect(() => {
    //
    isLoggedIn();
  }, [x]);

  useEffect(() => {
    if (posts.length > 0) {
      setDownloadFlag(true);
    } else {
      setDownloadFlag(false);
    }
  }, [posts]);

  //button search
  const filterData = () => {
    setDataLoaded(false);
    searchList();
  };

  const getList = async () => {
    setDataLoaded(false);
    await axios
      .post(process.env.REACT_APP_API_URL + "get_supplier_data", {
        supplier_name: "",
        idno: get_cookies("branchidno"),
      })
      .then(function (res) {
        // console.log("supplier", res);
        // setPosts(res.data[0]);
        setPosts(res.data.data);
        setDataLoaded(true);
      })
      .catch(function (error) {
        // console.log(error);
      });
    // .then((result) => {
    //   console.log("12", result);
    //   setPosts(result.data.data);
    //   setDataLoaded(true);
    // })
    // .catch((error) => {
    //   console.log(error.message);
    //   setDataLoaded(true);
    // });
  };
  const searchList = async () => {
    await axios
      .post(process.env.REACT_APP_API_URL + "get_supplier_data", {
        supplier_name: supplierName == "" ? "" : supplierName,
        idno: get_cookies("branchidno"),
      })
      .then(function (res) {
        // console.log("supplier", res);
        // setPosts(res.data[0]);
        setPosts(res.data.data);
        setDataLoaded(true);
      })
      .catch(function (error) {
        // console.log(error);
      });
    // .then((result) => {
    //   console.log("12", result);
    //   setPosts(result.data.data);
    //   setDataLoaded(true);
    // })
    // .catch((error) => {
    //   console.log(error.message);
    //   setDataLoaded(true);
    // });
  };
  const nameExists = posts.some((obj) => obj.suppliername.toLowerCase() === debouncedName); // checking name exist

  const save_entity = async () => {
    setBtnDisabled(true); // disable button to avoid multiple saves

    // setShowModal(true); //show loading/please wait modal
    const formData = new FormData();
    formData.append("suppliername", supplierName);
    formData.append("address", address);
    formData.append("contactno", contactNo);
    formData.append("contactperson", contactPerson);
    formData.append("credit", credit);
    formData.append("otherinfo", otherInfo);
    formData.append("branchidno", get_cookies("branchidno"));
    await axios
      .post(process.env.REACT_APP_API_URL + "add_supplier_data", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function (res) {
        setTimeout(() => {
          showModal("Succesfuly added supplier ", "success");
          setModalOpen(false);
        }, 2500);
      })
      .catch(function (error) {
        setShowMsgBox(true);
        showModal("Something went wrong: " + error, "error");
        setTimeout(() => {
          setDataLoaded(true);
          setBtnDisabled(false); // re-enable
        }, 2500);
      });
  };

  useEffect(() => {
    if ((filterType == "1" && idno) || (filterType == "2" && supplierName)) {
      setBtnDisabled(false); // re-enable
    }
    else if (nameExists == true){
      setBtnDisabled(false); // re-enable
    } else {
      setBtnDisabled(true); // re-enable
    }
  }, [idno, supplierName, filterType]);

  useEffect(() => {
    getCreditData();
    getList();
  }, []);

  const data = async () => {
    //get data from api (for table)
    // const res = await axios.get('http://127.0.0.1/jcphq_new/public/gl_tran_report', {
    // 	params:{
    // 		date_from:'2013/01/01/', //format(dateRange.startDate, "yyyy/MM/dd/")
    // 		date_to:'2014/12/01/',   //format(dateRange.endDate, "yyyy/MM/dd/")
    // 		account_type_id:'all', //glAccFilter
    // 		jc_u_idno:'DAVAOHQ',  //input text for branchidno
    // 	}
    // })
    //res.data.data because api data is wrapped in "data"
    // console.log(res.data.data[res.data.data.length - 1]); //get the last item (grandtotal object)
    // setPosts(res.data.data);
    //setDataLoaded(true);
  };
  const toggle = () => setOpen(!open);

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const dateRangeHandler = (range) => {
    setDateRange(range);
    setOpen(false);
  };

  const columns = [
    {
      name: "id",
      label: "ID",
    },
    {
      name: "suppliername",
      label: "Name",
    },
    {
      name: "contactno",
      label: "Contact No.",
    },
    {
      name: "description",
      label: "Credit Term",
    },
    {
      name: "contactperson",
      label: "Contact Person",
    },
    {
      name: "id",
      label: "Actions",
      options: {
        sort: false,
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          let position_id = posts[dataIndex].id;

          let position_name = posts[dataIndex].position;
          return (
            <Grid container spacing={8}>
              <Grid item xs={12} sm={12} md={5} lg={4} xl={3} key={position_id}>
                <UpdateSupplier
                  showModal={showModal}
                  supplier_id={posts[dataIndex].id}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={5} lg={4} xl={3} key={position_id}>
                <DeleteSupplier
                  showModal={showModal}
                  supplier_id={posts[dataIndex].id}
                />
              </Grid>
            </Grid>
          );
        },
      },
    },
  ];

  const options = {
    filter: false,
    // filterType: "dropdown",
    selectableRows: "none",
    filterType: "multiselect",
    responsive: "standard",
    setFilterChipProps: (colIndex, colName, data) => {
      //console.log(colIndex, colName, data);
      return {
        color: "primary",
        variant: "outlined",
        className: "testClass123",
      };
    },
    download: false, //add this
    print: false, //add this
    viewColumns: false,
    downloadOptions: {
      filename: "CustomerInfo.csv", //change filename of csv
    },
    // tableBodyHeight,
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedName(supplierName.toLowerCase());
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [supplierName]);
  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <AccountBalanceIcon />
        </div>
        <Breadcrumbs aria-label="breadcrumb">
          <NavLink to="/entity">
            <h2 className="header-title">Entity</h2>
          </NavLink>
          <Typography color="textPrimary">Supplier Information</Typography>
        </Breadcrumbs>
      </div>
      <div className="page-container">
        <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType} />
        <div>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={modalOpen}
            onClose={handleModalClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <div className={classes.paper}>
              <h2 id="transition-modal-title">Add Supplier</h2>
              <form action="" className={classes.root}>
                <div>
                  <TextField
                    id="outlined-full-width"
                    label="Supplier Name"
                    style={{ margin: 8 }}
                    placeholder="Enter Supplier Name"
                    fullWidth
                    margin="normal"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                    onChange={(e) => {
                      setSupplierName(e.target.value);
                    }}
                  />
                  {supplierName && (
                    <p style={{padding:0,color:'red'}}>
                      {nameExists
                        ? `Supplier "${debouncedName}" already exists.`
                        : null}
                    </p>
                  )}
                </div>
                <div>
                  <TextField
                    id="outlined-full-width"
                    label="Address"
                    style={{ margin: 8 }}
                    placeholder="Enter Address"
                    fullWidth
                    margin="normal"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                    onChange={(e) => {
                      setAddress(e.target.value);
                    }}
                  />
                </div>
                <div>
                  <TextField
                    id="outlined-full-width"
                    label="Contact Number"
                    style={{ margin: 8 }}
                    placeholder="Enter Contact Number"
                    fullWidth
                    margin="normal"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                    onChange={(e) => {
                      setContactNo(e.target.value);
                    }}
                  />
                </div>
                <div>
                  <TextField
                    id="outlined-full-width"
                    label="Contact Person"
                    style={{ margin: 8 }}
                    placeholder="Enter Contact Person"
                    fullWidth
                    margin="normal"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="outlined"
                    onChange={(e) => {
                      setContactPerson(e.target.value);
                    }}
                  />
                </div>

                <div style={{ marginLeft: 8, width: "100%" }}>
                  {/* <TextField id="outlined-basic" label="Branch Id No" variant="outlined" placeholder="Branch Id No" inputProps={{ 'aria-label': 'User Name' }} value={branchidno} onChange={e => setBranchidno(e.target.value)}/> */}
                  <Autocomplete
                    {...selectCreditProps}
                    id="auto-complete"
                    autoComplete
                    includeInputInList
                    className={classes.autoComplete}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Credit"
                        margin="normal"
                        variant="outlined"
                      />
                    )}
                    onChange={(event, newValue) => {
                      if (!newValue == "" || !newValue == null) {
                        setCredit(newValue.id);
                      } else {
                        setCredit(null);
                      }
                    }}
                  />
                </div>
                <div>
                  <Grid item>
                    <TextField
                      id="outlined-full-width"
                      label="Other Info"
                      style={{ margin: 8 }}
                      placeholder="Enter additional info"
                      fullWidth
                      margin="normal"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                      onChange={(e) => {
                        setOtherInfo(e.target.value);
                      }}
                    />
                  </Grid>
                </div>

                <div className={classes.button}>
                  <Grid
                    container
                    spacing={1}
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Grid item xs={12} sm={2}>
                      <Button
                        variant="contained"
                        onClick={handleModalClose}
                        className={classes.buttonMarginRight}
                      >
                        Close
                      </Button>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Button
                        // disabled={btnDisabled}
                        variant="contained"
                        color="primary"
                        onClick={(e) => {
                          save_entity();
                        }}
                      >
                        Add
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </form>
            </div>
          </Modal>
        </div>
        <div>
          <Grid container spacing={2} style={{ display: "flex" }}>
            <Grid item xs={12} sm={4} md={4} lg={3} xl={3}>
              <NativeSelect
                onChange={(e) => {
                  setFilterType(e.target.value);
                  setIdno("");
                  setSupplierName("");
                }}
                inputProps={{
                  name: "GL Account",
                }}
              >
                <option value={1}>Search By ID No.</option>
                <option value={2}>Search By Supplier Name</option>
              </NativeSelect>
            </Grid>
            {/* show specific input based on input */}
            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
              {filterType === "1" ? (
                <TextField
                  required
                  id="standard-required"
                  label="ID No"
                  inputProps={{ "aria-label": "description" }}
                  value={idno}
                  fullWidth={true}
                  onChange={(e) => setIdno(e.target.value)}
                  className={classes.textField}
                  error={idno === ""}
                  helperText={idno === "" ? "Required field" : " "}
                />
              ) : (
                <TextField
                  required
                  id="standard-required"
                  label="Supplier Name"
                  inputProps={{ "aria-label": "description" }}
                  value={supplierName}
                  fullWidth={true}
                  onChange={(e) => setSupplierName(e.target.value)}
                  className={classes.textField}
                  error={supplierName === ""}
                  helperText={supplierName === "" ? "Required field" : " "}
                />
              )}
            </Grid>
            <Grid item xs={4} sm={4} md={4} lg={1} xl={1}>
              <Button
                disabled={btnDisabled}
                variant="contained"
                color="primary"
                style={{ marginBottom: "12px" }}
                onClick={() => {
                  filterData();
                }}
              >
                Search
              </Button>
            </Grid>
            <Grid
              item
              xs={11}
              sm={10}
              md={10}
              lg={2}
              xl={2}
              style={{ marginLeft: "auto" }}
            >
              <Button
                // disabled={btnDisabled}
                variant="contained"
                color="primary"
                style={{ marginBottom: "12px" }}
                onClick={() => {
                  handleModalOpen();
                }}
              >
                Add Supplier
              </Button>
            </Grid>
          </Grid>
        </div>
        {!dataLoaded ? (
          <Preloader />
        ) : (
          <MUIDataTable
            title={
              <div>
                <h3 className="header-title" style={{ color: "#339933" }}>
                  Supplier
                </h3>
              </div>
            }
            data={posts}
            columns={columns}
            options={options}
          />
        )}
      </div>
    </div>
  );
};

export default SupplierInfo;
